module.exports = __webpack_public_path__ + "img/home0.9515c11e.png";